import { useAppSelector } from '@/store/hooks';
import { getWorkingProjectUuid, selectWorkingProjectDefaultLanguage } from '@/store/slices/project/selectors';
import { getBaseAdminURL } from '@/utils/urls';
import useLanguageParams from '@/utils/use-language-params';
import { useWorkingSession } from '@/utils/use-working-session';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import Link from '@ui/links/link';

const AddEngagementCard = () => {
  const workingProjectUuid = useAppSelector(getWorkingProjectUuid);
  const session = useWorkingSession();
  const paramsLanguage = useLanguageParams();
  const _defaultLanguage = useAppSelector(selectWorkingProjectDefaultLanguage);
  const language = paramsLanguage || _defaultLanguage || 'en';

  const url = `${getBaseAdminURL()}/admin/events/create/${workingProjectUuid}/session/${session?.uuid}/${language}/content/tabs/engage`;

  return (
    <Link
      className="clear-button"
      to={url}
      height="140px"
      width="320px"
      backgroundColor="rgba(var(--secondary-violet-500-rgb), 0.04)"
      hoverBackgroundColor="rgba(var(--secondary-violet-500-rgb), 0.08)"
      borderRadius="12px"
    >
      <Container
        width="100%"
        height="100%"
        borderRadius="12px"
        className="position-relative overflow-hidden flex fd-column jc-center ai-center"
      >
        <div className="margin-r-8 opacity-100">
          <Icon name={ICONS.ADD} size={16} color="var(--global-ico-text-1)" />
        </div>
        <div>
          <Text className="S2" design="GlobalIcoText1">
            Add engage
          </Text>
        </div>
      </Container>
    </Link>
  );
};

export default AddEngagementCard;
